module.exports = __webpack_public_path__ + "img/rainy-city-tram.1acd3ad4.jpg";